import type { State, UserRequestsCounts } from './types';

/**
 * User request counts selectors for accessing user request statistics.
 * These selectors are designed to avoid cyclic dependencies.
 */

export const getUserRequestsCounts = (state: State): UserRequestsCounts => {
    return state.persisted.userRequestsCounts;
};
